import { render, staticRenderFns } from "./CreateOrEditCategory.vue?vue&type=template&id=0ad938c4&scoped=true&"
import script from "./CreateOrEditCategory.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditCategory.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditCategory.vue?vue&type=style&index=0&id=0ad938c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad938c4",
  null
  
)

export default component.exports